import { render } from "./ExchangeProducts.vue?vue&type=template&id=f1ba5b00&scoped=true"
import script from "./ExchangeProducts.vue?vue&type=script&lang=js"
export * from "./ExchangeProducts.vue?vue&type=script&lang=js"

import "./ExchangeProducts.vue?vue&type=style&index=0&id=f1ba5b00&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ba5b00"]])

export default __exports__